import { useState, useEffect } from "react";

/**
 * useDarkMode — reads from localStorage (set by Navigation)
 * and listens to the "nexusflow:darkmode" custom event.
 * Mirrors the internal useDarkMode inside Navigation.jsx.
 */
export function useDarkMode() {
  const [darkMode, setDarkMode] = useState(() => {
    try {
      const saved = localStorage.getItem("nexusflow-theme");
      if (saved) return saved === "dark";
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    } catch { return true; }
  });

  useEffect(() => {
    const handler = (e) => setDarkMode(e.detail);
    window.addEventListener("nexusflow:darkmode", handler);
    return () => window.removeEventListener("nexusflow:darkmode", handler);
  }, []);

  return { darkMode };
}